import isEmpty from 'lodash/isEmpty'
import noop from 'lodash/noop'
import React, { useRef } from 'react'

import { TextArea } from '@Components/FormElements/UI/TextArea'
import { stripEmoji } from '@Components/Personalization/Util/helpers'

import styles from './GiftCard.module.scss'

// Measures rendered text width by briefly mounting an off-screen div.
function measureTextPixels(pText, pFontSize) {
  let lDiv: null | HTMLDivElement = document.createElement('div')
  document.body.appendChild(lDiv)
  lDiv.style.fontSize = `${pFontSize}px`
  lDiv.style.position = 'absolute'
  lDiv.style.left = '-1000px'
  lDiv.style.top = '-1000px'
  lDiv.textContent = pText
  const width = lDiv.clientWidth
  document.body.removeChild(lDiv)
  lDiv = null
  return width
}

export const GiftCardMessageInput = ({
  characterLimit = 250,
  message,
  lineNumberLimit = 7,
  onchange = noop,
  name = 'GiftCardMessage',
  id = 'GiftCardMessage',
  placeholder,
}: {
  characterLimit?: number
  id?: string
  lineNumberLimit?: number
  message: string
  name?: string
  onchange?: (message: string) => void
  placeholder?: string
}) => {
  const textAreaRef = useRef<HTMLDivElement>(null)

  const limitNewlines: (mess: string) => string = (mess) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const textarea: HTMLTextAreaElement = textAreaRef.current!.getElementsByTagName('textarea')[0]
    if (textarea?.style) {
      const computedStyled = window.getComputedStyle(textarea)
      const padding = +computedStyled.paddingLeft.replace(/[^0-9]/g, '')
      const border = +computedStyled.borderLeftWidth.replace(/[^0-9]/g, '')
      const size = textarea!.getBoundingClientRect()!.width - ((padding + border) * 2)
      const textPixels = measureTextPixels(mess, 12)
      let lineNumbers = textPixels / size
      lineNumbers += mess.split('\n').length
      lineNumbers = Math.floor(lineNumbers)
      if (lineNumbers > lineNumberLimit) {
        return stripEmoji(message)
      }
    }
    return stripEmoji(mess)
  }

  const limitCharacters: (mess: string) => string = (mess) => {
    const newMessage = mess
    if (newMessage && newMessage.length > characterLimit) {
      return message
    }
    return mess
  }

  const changeMessage = (messageChange) => {
    let newMessage = limitCharacters(messageChange)
    newMessage = limitNewlines(newMessage)
    onchange(newMessage)
  }

  return (
    <div ref={textAreaRef}>
      <TextArea
        className={styles.textArea}
        id={id}
        label={isEmpty(message) ? '' : `${message.length}/${characterLimit}`}
        name={name}
        onChange={change => changeMessage(change.currentTarget.value)}
        placeholder={isEmpty(message) ? placeholder : ''}
        value={message}
      />
    </div>
  )
}
